(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class MobileDisclosure extends DetailsDisclosure {
      constructor() {
        super();
        this.reset();
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
          this.querySelectorAll('.disclosure, .disclosure__title, .disclosure__panel, .disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(`mobile-${cl}`);
            });
          });
        } else {
          this.toggle.removeAttribute('tabindex');
          this.querySelectorAll('.mobile-disclosure, .mobile-disclosure__title, .mobile-disclosure__panel, .mobile-disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('mobile-disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(cl.substr(7));
            });
          });
        }
      }
    }

    customElements.define('mobile-disclosure', MobileDisclosure);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["legu-category-navigation"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('legu-category-navigation')) {
    class LeguCategoryNavigation extends HTMLElement {
      connectedCallback() {
        this.updateActiveLink();
      }

      normalizedUrl(value) {
        const url = new URL(value, window.location.origin);
        const ignoredParameters = new Set([
          '_pos',
          '_sid',
          '_ss',
          'page',
          'preview_theme_id',
          'sort_by',
        ]);
        const parameters = Array.from(url.searchParams.entries())
          .filter(([key]) => !ignoredParameters.has(key))
          .sort(([keyA, valueA], [keyB, valueB]) => {
            const keyComparison = keyA.localeCompare(keyB);
            return keyComparison || valueA.localeCompare(valueB);
          });
        const path = url.pathname.replace(/\/$/, '') || '/';
        const query = new URLSearchParams(parameters).toString();

        return query ? `${path}?${query}` : path;
      }

      setActiveLink(links, activeLink) {
        links.forEach((link) => {
          const isActive = link === activeLink;
          link.classList.toggle('is-active', isActive);
          if (isActive) {
            link.setAttribute('aria-current', 'page');
          } else {
            link.removeAttribute('aria-current');
          }
        });
      }

      updateActiveLink() {
        const links = Array.from(this.querySelectorAll('[data-legu-category-link]'));
        if (!links.length) return;

        const currentUrl = this.normalizedUrl(window.location.href);
        const exactMatch = links.find((link) => this.normalizedUrl(link.href) === currentUrl);
        const manualSelection = links.find((link) => link.classList.contains('is-active'));
        const activeLink = exactMatch || manualSelection;

        if (!activeLink) return;
        this.setActiveLink(links, activeLink);

        if (window.matchMedia('(max-width: 767.98px)').matches && this.classList.contains('legu-category-navigation--scroll')) {
          requestAnimationFrame(() => {
            activeLink.scrollIntoView({ behavior: 'auto', block: 'nearest', inline: 'center' });
          });
        }
      }
    }

    customElements.define('legu-category-navigation', LeguCategoryNavigation);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["legu-cuotas-sin-interes"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('legu-product-installments')) {
    class LeguProductInstallments extends HTMLElement {
      connectedCallback() {
        this.installmentCount = Math.max(1, Number(this.dataset.installments) || 1);
        this.showDecimals = this.dataset.showDecimals === 'true';
        this.moneyFormat = this.dataset.moneyFormat || '$' + '{' + '{amount}}';
        this.productId = String(this.dataset.productId || '');
        this.amountElement = this.querySelector('.legu-installments__amount');
        this.handleVariantChange = this.handleVariantChange.bind(this);
        document.addEventListener('on:variant:change', this.handleVariantChange);
        this.updateAmount(Number(this.dataset.price) || 0);
      }

      disconnectedCallback() {
        document.removeEventListener('on:variant:change', this.handleVariantChange);
      }

      handleVariantChange(event) {
        const variant = event.detail && event.detail.variant;
        if (!variant || typeof variant.price === 'undefined') return;
        if (variant.product_id && this.productId && String(variant.product_id) !== this.productId) return;
        this.updateAmount(Number(variant.price) || 0);
      }

      updateAmount(price) {
        if (!this.amountElement) return;
        let installmentPrice = price / this.installmentCount;
        if (!this.showDecimals) installmentPrice = Math.round(installmentPrice / 100) * 100;
        this.amountElement.textContent = this.formatMoney(installmentPrice);
      }

      formatMoney(cents) {
        const format = this.moneyFormat;
        const match = format.match(/\{\{\s*(\w+)\s*\}\}/);
        if (!match) return String((cents / 100).toFixed(this.showDecimals ? 2 : 0));

        const token = match[1];
        let thousands = ',';
        let decimal = '.';

        if (token.includes('comma_separator')) {
          thousands = '.';
          decimal = ',';
        } else if (token.includes('space_separator')) {
          thousands = ' ';
          decimal = ',';
        } else if (token.includes('apostrophe_separator')) {
          thousands = "'";
          decimal = '.';
        }

        const precision = this.showDecimals ? 2 : 0;
        const amount = this.withDelimiters(cents / 100, precision, thousands, decimal);
        return format.replace(match[0], amount);
      }

      withDelimiters(value, precision, thousands, decimal) {
        const fixed = Number(value || 0).toFixed(precision);
        const parts = fixed.split('.');
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
        return parts.length > 1 ? parts[0] + decimal + parts[1] : parts[0];
      }
    }

    customElements.define('legu-product-installments', LeguProductInstallments);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["legu-promos-banners"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('legu-promo-banners'))customElements.define('legu-promo-banners',class extends HTMLElement{connectedCallback(){this.cards=[...this.querySelectorAll('[data-card]')];this.track=this.querySelector('.lpb__grid');this.index=0;this.prev=this.querySelector('[data-prev]');this.next=this.querySelector('[data-next]');this.position=this.querySelector('[data-position]');this.media=matchMedia('(max-width:749px)');this.prev?.addEventListener('click',e=>{this.go(-1);e.currentTarget.blur()});this.next?.addEventListener('click',e=>{this.go(1);e.currentTarget.blur()});this.cards.forEach((card,i)=>card.addEventListener('click',e=>{if(!this.stacked||i===this.index)return;e.preventDefault();this.index=i;this.render();this.restart()}));let start=0;this.track.addEventListener('pointerdown',e=>{start=e.clientX;this.pause()});this.track.addEventListener('pointerup',e=>{if(!this.stacked)return;const delta=e.clientX-start;if(Math.abs(delta)>35)this.go(delta<0?1:-1);this.restart()});this.track.addEventListener('scroll',()=>{if(this.mode!=='carousel')return;cancelAnimationFrame(this.raf);this.raf=requestAnimationFrame(()=>this.read())},{passive:true});this.addEventListener('mouseenter',()=>this.pause());this.addEventListener('mouseleave',()=>this.restart());this.addEventListener('focusin',()=>this.pause());this.addEventListener('focusout',()=>this.restart());this.onMedia=()=>this.applyMode();this.media.addEventListener('change',this.onMedia);this.applyMode()}disconnectedCallback(){this.pause();this.media?.removeEventListener('change',this.onMedia)}applyMode(){this.mode=this.media.matches?this.dataset.mobileMode:this.dataset.desktopMode;this.stacked=this.mode==='stacked';this.classList.remove('lpb--grid','lpb--carousel','lpb--stacked');this.classList.add('lpb--'+this.mode);this.cards.forEach(card=>{card.removeAttribute('data-pos');card.removeAttribute('aria-hidden');card.removeAttribute('tabindex')});if(this.stacked)this.render();else this.updatePosition();this.restart()}go(step){if(!this.cards.length||this.mode==='grid')return;this.index=(this.index+step+this.cards.length)%this.cards.length;if(this.stacked)this.render();else this.track.scrollTo({left:this.cards[this.index].offsetLeft-this.track.offsetLeft,behavior:'smooth'});this.restart()}read(){if(!this.cards.length)return;const left=this.track.scrollLeft;this.index=this.cards.reduce((best,card,i)=>Math.abs(card.offsetLeft-left)<Math.abs(this.cards[best].offsetLeft-left)?i:best,0);this.updatePosition()}render(){const total=this.cards.length;this.cards.forEach((card,i)=>{card.removeAttribute('data-pos');card.setAttribute('aria-hidden','true');card.setAttribute('tabindex','-1');if(i===this.index){card.dataset.pos='active';card.removeAttribute('aria-hidden');card.removeAttribute('tabindex')}else if(i===(this.index-1+total)%total)card.dataset.pos='prev';else if(i===(this.index+1)%total)card.dataset.pos='next'});this.updatePosition()}updatePosition(){if(this.position)this.position.textContent=`${this.index+1} / ${this.cards.length}`}pause(){clearInterval(this.timer)}restart(){this.pause();const delay=Number(this.dataset.autoplay);if(this.mode==='grid'||delay<=0||matchMedia('(prefers-reduced-motion: reduce)').matches)return;this.timer=setInterval(()=>this.go(1),delay)}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["legu-promos-duos"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('legu-duos'))customElements.define('legu-duos',class extends HTMLElement{connectedCallback(){this.ac=new AbortController;const o={signal:this.ac.signal},t=this.querySelector('[data-track]');this.querySelector('[data-prev]').onclick=e=>{this.pause();this.move(-1);e.currentTarget.blur()};this.querySelector('[data-next]').onclick=e=>{this.pause();this.move(1);e.currentTarget.blur()};t.addEventListener('scroll',()=>{cancelAnimationFrame(this.raf);this.raf=requestAnimationFrame(()=>this.count())},{...o,passive:true});['pointerdown','mouseenter','focusin','touchstart'].forEach(e=>this.addEventListener(e,()=>this.pause(),{...o,passive:true}));this.addEventListener('mouseleave',()=>this.autoplay(),o);this.querySelectorAll('[data-open]').forEach(b=>{const d=this.querySelector('#'+b.dataset.open);b.onclick=()=>{this.pause();d.showModal();this.show(d,1)};d.querySelector('[data-close]').onclick=()=>d.close();d.onclick=e=>{if(e.target===d)d.close()};d.addEventListener('close',()=>this.autoplay(),o)});this.querySelectorAll('[data-tab]').forEach(b=>b.onclick=()=>this.show(b.closest('dialog'),+b.dataset.tab));this.querySelectorAll('[data-product]').forEach(b=>b.onclick=()=>this.product(b));this.querySelectorAll('.ld__dialog form:not(.js-back-in-stock)').forEach(f=>f.onsubmit=e=>this.submit(e));const guide=this.querySelector('[data-guide]');this.querySelectorAll('[data-size-guide]').forEach(b=>b.onclick=()=>this.guide(b));guide.querySelector('[data-guide-close]').addEventListener('click',()=>guide.close(),o);guide.addEventListener('click',e=>{const r=guide.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)guide.close()},o);this.querySelectorAll('[data-bis-close]').forEach(b=>b.onclick=()=>b.closest('[data-bis]').style.display='none');this.count();this.autoplay()}disconnectedCallback(){this.pause();this.ac?.abort()}move(n){const t=this.querySelector('[data-track]'),a=[...t.querySelectorAll('[data-slide]')],s=a[0],i=Math.round(t.scrollLeft/(s.offsetWidth+12)),next=(i+n+a.length)%a.length;t.scrollTo({left:next*(s.offsetWidth+12),behavior:'smooth'});a[next].querySelector('[data-open]').toggleAttribute('data-auto-active',true);setTimeout(()=>a[next]?.querySelector('[data-open]')?.removeAttribute('data-auto-active'),650)}count(){const t=this.querySelector('[data-track]'),a=[...t.querySelectorAll('[data-slide]')],s=a[0];if(!s)return;const i=Math.min(a.length-1,Math.max(0,Math.round(t.scrollLeft/(s.offsetWidth+12))));this.querySelector('[data-count]').textContent=`${i+1} / ${a.length}`}autoplay(){this.pause();if(matchMedia('(prefers-reduced-motion: reduce)').matches||document.hidden||this.querySelector('dialog[open]'))return;this.timer=setInterval(()=>this.move(1),4800)}pause(){clearInterval(this.timer)}show(d,n){d.querySelectorAll('[data-panel]').forEach(p=>p.hidden=+p.dataset.panel!==n);d.querySelectorAll('[data-tab]').forEach(b=>b.setAttribute('aria-current',+b.dataset.tab===n?'step':'false'))}async product(b){const p=b.closest('[data-panel]'),box=p.querySelector('[data-variants]'),list=p.querySelector('[data-variant-list]'),status=p.querySelector('[data-status]');p.querySelectorAll('[data-product]').forEach(x=>x.setAttribute('aria-pressed',x===b));p.dataset.variant='';p.dataset.title=b.dataset.title;p.dataset.url=b.dataset.url;box.hidden=false;list.replaceChildren();status.textContent=this.dataset.loading;try{const u=new URL(b.dataset.url,location.origin);u.pathname=u.pathname.replace(/\/$/,'')+'.js';u.search='';const r=await fetch(u,{credentials:'same-origin',headers:{Accept:'application/json'}});if(!r.ok)throw Error();const data=await r.json();const options=data.options||[],sizeIndex=options.findIndex(o=>{const n=String(o.name||o).toLowerCase();return n.includes('talle')||n.includes('talla')||n.includes('size')}),variants=sizeIndex<0?data.variants.slice(0,1):data.variants;box.querySelector('[data-size-guide]').hidden=sizeIndex<0;variants.forEach(v=>{const x=document.createElement('button'),label=sizeIndex<0?this.dataset.oneSize:(v.options?.[sizeIndex]||v.title.split(' / ').at(-1));x.type='button';x.dataset.variant=v.id;x.dataset.available=v.available;x.dataset.size=label;x.setAttribute('aria-pressed','false');x.append(document.createTextNode(label));if(!v.available){x.className='ld__sold';x.title=this.dataset.soldOut;const bell=document.createElementNS('http://www.w3.org/2000/svg','svg');bell.setAttribute('viewBox','0 0 24 24');bell.innerHTML='<path d="M18 8a6 6 0 0 0-12 0c0 7-3 7-3 9h18c0-2-3-2-3-9M10 21h4"/>';x.append(bell)}x.onclick=()=>v.available?this.variant(x):this.notify(x);list.append(x)});status.textContent=list.children.length?'':this.dataset.error}catch{status.textContent=this.dataset.error}}async guide(b){const p=b.closest('[data-panel]'),d=this.querySelector('[data-guide]'),title=d.querySelector('[data-guide-title]'),content=d.querySelector('[data-guide-content]');title.textContent=this.dataset.sizeGuide;content.innerHTML='<p>'+this.dataset.guideLoading+'</p>';d.showModal();try{const r=await fetch(p.dataset.url,{credentials:'same-origin'});if(!r.ok)throw Error();const doc=new DOMParser().parseFromString(await r.text(),'text/html'),source=doc.querySelector('modal-dialog[id^="size-chart-"] .modal__content');if(!source)throw Error();title.textContent=source.closest('modal-dialog')?.getAttribute('aria-label')||this.dataset.sizeGuide;content.innerHTML=source.innerHTML}catch{const fallback=d.querySelector('[data-guide-fallback]').innerHTML;content.innerHTML=fallback||'<p>'+this.dataset.guideError+'</p>'}}notify(b){const p=b.closest('[data-panel]'),d=p.closest('.ld__dialog'),m=d.querySelector('[data-bis]');m.querySelector('[data-bis-product]').textContent=`${p.dataset.title} · ${b.dataset.size}`;const input=m.querySelector('[data-bis-variant]'),id=b.dataset.variant;input.value=id;input.setAttribute('value',id);m.style.display='flex';requestAnimationFrame(()=>{input.value=id;input.setAttribute('value',id)})}variant(b){const p=b.closest('[data-panel]'),d=p.closest('dialog'),n=+p.dataset.panel;p.querySelectorAll('[data-variant]').forEach(x=>x.setAttribute('aria-pressed',x===b));p.dataset.variant=b.dataset.variant;d.querySelector(`[data-tab="${n}"] [data-summary]`).textContent=`${p.dataset.title} · ${b.dataset.size}`;if(n===1&&!d.querySelector('[data-panel="2"]').dataset.variant)this.show(d,2);d.querySelector('[data-submit]').disabled=![...d.querySelectorAll('[data-panel]')].every(x=>x.dataset.variant)}async submit(e){e.preventDefault();const f=e.currentTarget,p=[...f.querySelectorAll('[data-panel]')];if(!p.every(x=>x.dataset.variant)||f.dataset.busy)return;const q=new Map;p.forEach(x=>q.set(x.dataset.variant,(q.get(x.dataset.variant)||0)+1));const b=f.querySelector('[data-submit]'),label=b.textContent;f.dataset.busy=1;b.disabled=true;b.textContent='…';try{const r=await fetch(this.dataset.add,{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:[...q].map(([id,quantity])=>({id,quantity}))})});if(!r.ok)throw Error();location.assign(this.dataset.cart)}catch{f.dataset.busy='';b.disabled=false;b.textContent=label;const x=f.querySelector('[data-form-error]');x.textContent=this.dataset.cartError;x.hidden=false}}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
